import { PlanningMenu } from './planning-menu';
import { ProfileNutrition } from './profile-nutrition';

export class DayMenu {
    Id: number;
    Name: string;
    IsHidden: boolean;
    IsNutritionHidden: number;
    Menu: PlanningMenu[] = [];
    Nutrition: ProfileNutrition[] = [];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/day-menu.ts